import { NotificationType } from './notificationType';

export enum NotificationStatus {
  pending = 'pending',
  skipped = 'skipped',
  sent = 'sent', // unread
  read = 'read',
  error = 'error',
  deleted = 'deleted',
}

export enum MessageChannelType {
  push = 'push',
  email = 'email',
  text = 'text',
}

export interface NotificationPayload {
  body: undefined | string | ((args: unknown) => undefined | string);
  title?: string;
  data?: { notificationType: string; createdAt: number; notificationTypeCategory: string } & Record<string, any>;
}

export interface PushNotificationPayload extends NotificationPayload {
  title: string;
  sound?: string;
  badge?: number;
  data?: any;
  platform?: string;
  appVersion?: string;
  imageUrl?: string;
}

export interface TextNotificationPayload extends NotificationPayload {
  messageMediaUri?: string;
  messageType: '2FA' | 'MARKETING' | 'LAUNCH';
}

export interface EmailNotificationPayload extends NotificationPayload {
  subject?: string;
}

export enum NotificationTypeCategory {
  messagingCampaign = 'messagingCampaign',
  rewardsEarned = 'rewardsEarned',
  payouts = 'payouts',
  rewardsSummary = 'rewardsSummary',
  customPush = 'customPush',
  customText = 'customText',
  accountEngagement = 'accountEngagement',
  rewardTypeReminder = 'rewardTypeReminder',
}

export interface BuildNotificationData<T = object> {
  userId: string;
  notificationType: NotificationType;
  notificationTypeCategory?: NotificationTypeCategory;
  brandId?: number;
  data?: T;
}

export interface UserNotificationDto {
  notificationType: string;
  status: string;
  version: string;
  createdAt: number;
  payload: NotificationPayload;
}

export type NotificationPayloadTypeAlias =
  | PushNotificationPayload
  | TextNotificationPayload
  | EmailNotificationPayload
  | undefined;

export type NotificationsByUser = { [userId: string]: UserNotificationDto[] };
